import styles from "./Balance.module.scss";
import {Money as MoneyComponent} from "../../../common";
import React from "react";
import {useMyMoneyData} from "../../../../hooks/useMyMoneyData";

export const Balance = () => {
  const {depositSum, investedSum, returned, withdrawn, balance, reserved, free} = useMyMoneyData().balanceStats;
  const data = [
    {label: 'Зачислено', value: depositSum},
    {label: 'Инвестировано', value: investedSum},
    {label: 'Возвращено', value: returned},
    {label: 'Выведено', value: withdrawn},
    {label: 'Баланс', value: balance},
    {label: 'Бронировано', value: reserved},
  ];

  return (
    <div className={styles.balance}>
      <h2 className={styles.balance__title}>Баланс счета</h2>
      <ul className={styles.balance__list}>
        {data.map((item, index) => (
          <li key={index} className={styles.balance__item}>
            <span className={styles.balance__label}>{item.label}</span>
            {
              item.value ? <MoneyComponent money={item.value}/> : '-'
            }
          </li>
        ))}
      </ul>
      <div className={styles.balance__free}>
        <span>Свободно</span>
        <div className={styles.balance__freeValue}><MoneyComponent money={free}/></div>
      </div>
    </div>
  );
};